import { i as s } from "./index875.mjs";
import { i as t } from "./index870.mjs";
import { i as a } from "./index778.mjs";
import { w as n } from "./index760.mjs";
var i = s, f = t, c = a, m = n, u = m("species"), e = Array, d = function(o) {
  var r;
  return i(o) && (r = o.constructor, f(r) && (r === e || i(r.prototype)) ? r = void 0 : c(r) && (r = r[u], r === null && (r = void 0))), r === void 0 ? e : r;
};
export {
  d as a
};
